import { render, staticRenderFns } from "./point_label.vue?vue&type=template&id=18bb68d9&scoped=true&"
import script from "./point_label.vue?vue&type=script&lang=ts&"
export * from "./point_label.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18bb68d9",
  null
  
)

export default component.exports